<template>
  <!-- <ConfigProvider :locale="locale"> -->
  <router-view />
  <!-- </ConfigProvider> -->
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data() {
    return {
      locale: zhCN,
    }
  },
  methods: {
  },
  created() {

  },
  mounted() {
  },
  computed: {
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: red;
}
</style>
